/* Lower HQ: links to collections open in the "In stock" view by default.
   Leaves filter/sort/pagination links alone so shoppers can still see everything. */
(function () {
  var PARAM = 'filter.v.availability';
  var KEEP = 'facet-filters-form, facet-remove, .facets, .active-facets, .pagination, [data-lhq-keep]';
  var re = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^\/]+\/?$/i;
  function fix(a) {
    if (!a || !a.href || a.closest(KEEP)) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return; }
    if (u.origin !== location.origin || !re.test(u.pathname) || u.search) return;
    u.searchParams.set(PARAM, '1');
    a.href = u.toString();
  }
  function run() { document.querySelectorAll('a[href*="/collections/"]').forEach(fix); }
  document.addEventListener('DOMContentLoaded', run);
  ['mouseover', 'focusin', 'mousedown', 'touchstart'].forEach(function (t) {
    document.addEventListener(t, function (e) { fix(e.target.closest && e.target.closest('a')); }, { capture: true, passive: true });
  });
})();
